import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { CorporationsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};

export const schemaCorporationResolver_Get = CorporationsTableDefinitionZod.nullable();

export type SchemaCorporationResolver_Get = z.infer<typeof schemaCorporationResolver_Get>;

export type CorporationResolver_Get = Resolver<Arguments, SchemaCorporationResolver_Get>;
